import SelectColTable from '@/components/SelectColTable.vue';
import FooterControl from '@/components/FooterControl.vue';
import { pageSizes, drugType } from '@/config/constant';
import HisAutocompleteSuggestions from '@/components/HisAutocompleteSuggestions/index.vue';
import { REG_T_ZEAR } from '@/utils/validate/regExp';

export default {
  name: 'home',
  components: { SelectColTable, FooterControl, HisAutocompleteSuggestions },
  data() {
    return {
      title: this.$route.query.type && this.$route.query.type === 2 ? '修改盘点' : '新增盘点',
      pageSizes, // 分页数值
      drugType, // 药品分类列表
      isBatchNo: false, // 是否按批次盘点
      empty: false,
      query: {
        stocktakingId: this.$route.query.id || '',
        drugType: -1,
        drugName: '',
        customType: '',
        emptyShow: 0,
      }, // 查询筛选参数
      orderBySql: null,
      remark: '', // 备注
      noStocktaking: [], // 未盘点列表
      stocktaking: [], // 已盘点列表
      total: 0, // 总数据条数
      pageSize: 20, // 每页数据条数
      currentPage: 1, // 页码 从1开始
      total1: 0, // 总数据条数
      pageSize1: 20, // 每页数据条数
      currentPage1: 1, // 页码 从1开始
      time: new Date(),
      activeName: 'first',
      rowList: [
        {
          name: '厂家',
          value: 'manufacturer',
          minWidth: '140',
          isSortable: false,
          disabled: false,
          checked: true,
        },
        {
          name: '上次盘点时间',
          value: 'stocktakingTime',
          minWidth: '130',
          isSortable: 'custom',
          disabled: false,
          checked: false,
        },
        {
          name: '货架码',
          value: 'shelfCode',
          minWidth: '88',
          isSortable: 'custom',
          disabled: false,
          checked: false,
        },
        {
          name: '批号',
          value: 'drugBatchNo',
          minWidth: '',
          isSortable: false,
          disabled: false,
          checked: true,
        },
        {
          name: '有效期',
          value: 'validityDate',
          minWidth: '',
          isSortable: false,
          disabled: false,
          checked: false,
        },
        {
          name: '进货价',
          value: 'purchasePrice',
          minWidth: '',
          isSortable: false,
          disabled: false,
          checked: false,
        },
        {
          name: '零售价',
          value: 'prescriptionPrice',
          minWidth: '',
          isSortable: false,
          disabled: false,
          checked: false,
        },
      ],
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() >= Date.now();
        },
      },
      isShopDrugs: 0,
    };
  },
  mounted() {
    this.getTableData(1);
  },
  methods: {
    // ratio 换算比：相对于最小单位（适用全文）
    // 药品名称检索
    querySearch(str, cb) {
      this.isShopDrugs = 0;
      this.$api.drugControl.drugsNameList({ drugName: str }).then((res) => {
        if (Array.isArray(res.drugList) && res.drugList.length > 0) {
          cb(res.drugList);
        } else {
          cb([]);
        }
      });
    },
    // 选择药品名称
    selectHandle(e) {
      this.query.drugName = e.drugName;
      this.isShopDrugs = e.isShopDrugs;
      this.getTableData(1);
    },
    searchHandel(e) {
      this.query.drugName = e;
      this.getTableData(1);
    },
    // 取消盘点
    cancel() {
      this.$confirm('盘点未完成，取消后将清空本次盘点数据并解除库房锁定', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      }).then(() => {
        this.$api.drugControl.delStocktaking({
          id: this.query.stocktakingId,
        }).then(() => {
          this.goback();
        });
      }).catch(() => {
      });
    },
    // 完成盘点
    complete() {
      this.$confirm('是否完成盘点?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.query.emptyShow = this.empty ? 1 : 0;
        this.$api.drugControl.updateStocktaking({
          id: this.query.stocktakingId,
          status: 0, // 提交
          remark: this.remark,
          ...this.query,
        }).then(() => {
          this.goback();
        });
      }).catch(() => {
      });
    },
    // 返回
    goback() {
      this.$router.push({ name: 'inventory' });
    },
    // 确认盘点（单条）
    queryInventory(row, index) {
      this.$api.drugControl.stocktakingDetail({
        ...row,
        stocktakingId: this.query.stocktakingId,
      }).then(() => {
        this.noStocktaking.splice(index, 1);
        // 一页盘点完之后请求后台数据
        if (this.noStocktaking.length <= 0) {
          this.currentPage = 1;
          this.notStocktaking();
        }
        this.total -= 1;
        this.currentPage1 = 1;
        this.alStocktaking();
      });
    },
    // 取消盘点（单条）
    cancelInventory(row, index) {
      this.$api.drugControl.stocktakingDetailDel({
        ...row,
        stocktakingId: this.query.stocktakingId,
      }).then(() => {
        this.stocktaking.splice(index, 1);
        this.total1 -= 1;
        // 一页盘点完之后请求后台数据
        if (this.stocktaking.length <= 0) {
          this.currentPage1 = 1;
          this.alStocktaking();
        }
        this.currentPage = 1;
        this.notStocktaking();
      });
    },
    // 编辑药品总数量（增加：对第一个批次进行增加；减少：按批次顺序进行减少）
    editNumSum(editNum, indexs, index) {
      let oldNum = 0; // 此次编辑之前的实际(批次)数量总和
      let newNum = 0; // 此次编辑之后计算第一个批次的数量
      const num = editNum; // 编辑的数量
      let realNum = 0; // 此次编辑之后的实际数量总和
      const batch = this.noStocktaking[indexs].stocktakingDetailBatch; // 批次数据
      if (batch.length < 1) {
        this.$message.error('批次数据为空！');
        return;
      }
      // 计算批次数量总和（转换成最小换算单位）
      for (let i = 0; i < batch.length; i++) {
        for (let j = 0; j < batch[i].real.length; j++) {
          oldNum += Number(batch[i].real[j].num) * Number(batch[i].real[j].ratio);
        }
      }
      this.$set(this.noStocktaking[indexs].real[index], 'num', num); // 设置编辑的数量
      // 计算修改后总数量之和（转换成最小换算单位）
      this.noStocktaking[indexs].real.forEach((item) => {
        realNum += Number(item.num) * Number(item.ratio);
      });
      const con = Number(oldNum) - Number(realNum); // 比较编辑之前减少的数量
      // 数量减少
      if (con > 0) {
        let conNum = 0; // 当前实际数量总和
        for (let i = 0; i < batch.length; i++) {
          for (let j = 0; j < batch[i].real.length; j++) {
            conNum += Number(batch[i].real[j].num) * Number(batch[i].real[j].ratio);
          }
          // 按批次先后顺序计算（逐步相减）-数量够减
          if (conNum > con) {
            const newNumSum = conNum - con;
            if (batch[i].real.length === 1) {
              this.$set(batch[i].real[0], 'num', parseInt(newNumSum, 10));
            } else if (batch[i].real.length === 2) {
              const x = newNumSum / batch[i].real[0].ratio;
              this.$set(batch[i].real[0], 'num', parseInt(x, 10));
              this.$set(batch[i].real[1], 'num', parseInt(newNumSum % batch[i].real[0].ratio, 10));
            } else if (batch[i].real.length === 3) {
              const x = parseInt(newNumSum / (batch[i].real[0].ratio), 10);
              this.$set(batch[i].real[0], 'num', parseInt(x, 10));
              this.$set(batch[i].real[1], 'num', parseInt((newNumSum - x * batch[i].real[0].ratio) / batch[i].real[1].ratio, 10));
              this.$set(batch[i].real[2], 'num', parseInt((newNumSum - x * batch[i].real[0].ratio) % batch[i].real[1].ratio, 10));
            }
            return;
          }
          // 数量不够减，将批次数量置为0
          batch[i].real.forEach((item, idx) => {
            this.$set(batch[i].real[idx], 'num', 0);
          });
        }
      } else {
        // 总数量增加时，对‘第一个批次’的药品增加数量
        // 第一个批次数量之和（转换成最小换算单位）
        batch[0].real.forEach((item) => {
          newNum += Number(item.num) * Number(item.ratio);
        });
        // 第一个批次+增加的数量
        newNum -= Number(con);
        if (batch[0].real.length === 1) {
          // 一级单位
          const num0 = parseInt(newNum, 10);
          this.$set(batch[0].real[0], 'num', num0);
        } else if (batch[0].real.length === 2) {
          // 二级单位
          const x = newNum / batch[0].real[0].ratio;
          const num0 = parseInt(x, 10);
          const num1 = parseInt(newNum % batch[0].real[0].ratio, 10);
          this.$set(batch[0].real[0], 'num', num0);
          this.$set(batch[0].real[1], 'num', num1);
        } else if (batch[0].real.length === 3) {
          // 三级单位
          const x = parseInt(newNum / (batch[0].real[0].ratio), 10);
          const num0 = parseInt(x, 10);
          const num1 = parseInt((newNum - x * batch[0].real[0].ratio) / batch[0].real[1].ratio, 10);
          const num2 = parseInt((newNum - x * batch[0].real[0].ratio) % batch[0].real[1].ratio, 10);
          this.$set(batch[0].real[0], 'num', num0);
          this.$set(batch[0].real[1], 'num', num1);
          this.$set(batch[0].real[2], 'num', num2);
        }
      }
    },
    // 编辑药品数量（按批次盘点）
    editNum(num, indexs, index, findex) {
      const isNum = REG_T_ZEAR.test(num);
      if (num === '' || !isNum) {
        // 非法输入赋值为0
        this.$set(this.noStocktaking[findex].stocktakingDetailBatch[indexs].real[index], 'num', 0);
      }
      this.getUnit(this.noStocktaking[findex].stocktakingDetailBatch, findex, this.noStocktaking[findex].real);
    },
    addNum(e, editNum, indexs, index) {
      const isNum = REG_T_ZEAR.test(editNum);
      let editNumCopy = editNum;
      // 输入非法则置为0
      if (!isNum) {
        editNumCopy = 0;
      }
      this.editNumSum(editNumCopy, indexs, index);
    },
    // 获取未盘点列表信息
    getTableData(type) {
      if (type === 1) {
        this.currentPage = 1;
        this.currentPage1 = 1;
      }
      this.notStocktaking();
      this.alStocktaking();
    },
    // 排序
    sortChange(column) {
      let sort = '';
      if (column.order === 'ascending') {
        sort = 'asc';
      } else if (column.order === 'descending') {
        sort = 'desc';
      }
      this.orderBySql = `${column.prop} ${sort}`;
      this.currentPage = 1;
      this.notStocktaking();
    },
    // 获取未盘点列表信息
    notStocktaking() {
      this.query.emptyShow = this.empty ? 1 : 0;
      this.$api.drugControl.notStocktaking({
        ...this.query,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        orderBySql: this.orderBySql,
      }).then((res) => {
        this.noStocktaking = res.stocktakingDetail;
        this.total = res.totalSize;
      });
    },
    // 已盘点列表信息
    alStocktaking() {
      this.query.emptyShow = this.empty ? 1 : 0;
      this.$api.drugControl.alStocktaking({
        ...this.query,
        currentPage: this.currentPage1,
        pageSize: this.pageSize1,
      }).then((res) => {
        this.stocktaking = res.stocktakingDetail;
        this.total1 = res.totalSize;
      });
    },

    // 导出盘点单
    exportCheckList() {
      if (this.stocktaking.length < 1 && this.noStocktaking.length < 1) {
        this.$alert('没有盘点单信息，请更换查询条件试试', '提示', {
          confirmButtonText: '确定',
        }).catch(() => {
        });
      } else {
        this.query.emptyShow = this.empty ? 1 : 0;
        this.$api.drugControl.stocktakingExport({
          ...this.query,
          useDrugBathchNo: this.isBatchNo ? 1 : 0,
        });
      }
    },
    // 自定义分类检索
    querySearchCustomType(queryString, cb) {
      this.$api.drugControl.customType({
        customType: this.query.customType,
      }).then((res) => {
        let customTypeList = [];
        customTypeList = res.typeList.map(item => ({ value: item }));
        cb(customTypeList);
      });
    },
    // 选择下拉框自定义分类
    handleSelectCustomType(item) {
      this.query.customType = item.value;
      this.getTableData(1);
    },
    getRowClass({ row }) {
      // 即没有子元素时，添加row-expand-cover类,隐藏展开icon
      if (row.stocktakingDetailBatch && row.stocktakingDetailBatch.length < 2) {
        return 'row-expand-cover';
      }
      return '';
    },
    getTableCol(e) {
      this.rowList = e;
    },
    // 每页展示数据条数变更
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.notStocktaking();
    },
    // 翻页
    handleCurrentChange(value) {
      this.currentPage = value;
      this.notStocktaking();
    },
    // 每页展示数据条数变更
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.currentPage1 = 1;
      this.alStocktaking();
    },
    // 翻页
    handleCurrentChange1(value) {
      this.currentPage1 = value;
      this.alStocktaking();
    },
    // 实际数量总和
    getUnit(stocktakingDetailBatch, indexss, arr) {
      let realNum = 0; // 批次总数量
      stocktakingDetailBatch.forEach((item) => {
        item.real.forEach((i) => {
          realNum += Number(i.num) * Number(i.ratio);
        });
      });
      if (arr.length === 1) {
        this.noStocktaking[indexss].real[0].num = parseInt(realNum, 10);
      } else if (arr.length === 2) {
        const x = realNum / arr[0].ratio;
        const num0 = parseInt(x, 10);
        const num1 = parseInt(realNum % arr[0].ratio, 10);
        this.noStocktaking[indexss].real[0].num = num0;
        this.noStocktaking[indexss].real[1].num = num1;
      } else if (arr.length === 3) {
        const x = parseInt(realNum / (arr[0].ratio), 10);
        const num0 = parseInt(x, 10);
        const num1 = parseInt((realNum - x * arr[0].ratio) / arr[1].ratio, 10);
        const num2 = parseInt((realNum - x * arr[0].ratio) % arr[1].ratio, 10);
        this.noStocktaking[indexss].real[0].num = num0;
        this.noStocktaking[indexss].real[1].num = num1;
        this.noStocktaking[indexss].real[2].num = num2;
      }
    },
    // 计算盈亏数量
    getNum(real, book) {
      let plNum = [];
      let realNum = 0;
      let bookNum = 0;
      let units = '';
      let num = 0;
      let dis = 0; // 商
      let remainder = 0; // 余数
      // 实际数量总和（换算成最小单位）
      real.forEach((item) => {
        realNum += Number(item.num) * Number(item.ratio);
      });
      // 账面数量总和（换算成最小单位）
      book.forEach((item) => {
        bookNum += Number(item.num) * Number(item.ratio);
      });
      num = Number(realNum) - Number(bookNum);
      if (num < 0) {
        units = '-';
      } else if (num > 0) {
        units = '+';
      }
      num = Math.abs(num); // 绝对值
      real.forEach((item, index) => {
        if (index === 0) {
          dis = parseInt(num / (item.ratio), 10);
          remainder = num % (item.ratio);
        } else {
          dis = parseInt(remainder / (item.ratio), 10);
          remainder %= item.ratio;
        }
        if (dis > 0) {
          plNum += `${dis}${item.unit}`;
        }
      });
      return `${units}${plNum}`;
    },
  },
  computed: {
    noStocktakingNum() {
      return `待盘点(${this.total})`;
    },
    stocktakingNum() {
      return `已盘点(${this.total1})`;
    },
  },
};
